import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders} from '@angular/common/http';
import * as alertify from 'alertifyjs';
import { ServerDate } from '../views/courier/entry/pod/ServerDate';

@Injectable({
  providedIn: 'root'
})

export class PiyushService {
  public _httpClient;
  //public _apiURI = 'https://sbslogistics.co.in/portalapi/';
  //public _apiURI = 'https://excellentlogisticsolutions.com/portalapi/';
  //public _apiURI = 'https://s-slogistic.in/portalapi/';
  //public _apiURI = 'https://linkwayxpresslogistics.com/portalapi/';
  
  public _apiURI = 'https://excellentlogisticsolutions.com/portalapidemo/';
  //public _apiURI = 'https://localhost:5001/';
  public _reportURI = "https://excellentlogisticsolutions.com/portalReport/api/report/GetReport";
  constructor(public httpClient: HttpClient) { 
    this._httpClient = httpClient;
  }
  confirm(title: any,msg : any,ok: any,cancel: any)
  {
    alertify.confirm(title,msg,ok,cancel);
  }
  success(msg : string)
  {
    alertify.success(msg)
  }
  error(msg : string)
  {
    alertify.error(msg)
  }
  getData(uri: string,data : any)
  {
  
      return this._httpClient.post(this._apiURI+uri,data);
  }
  getReport(data : any)
  {
  
      return this._httpClient.post(this._reportURI,data,{Headers,responseType:'blob' as 'json'});
  }

}
